import { Component } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NotificationDialogComponent, NotificationDialogModel } from '../dialogs/notification-dialog/notification-dialog.component';
import { SingleEntryDialogComponent, SingleEntryDialogModel, SingleEntryDialogResult } from '../dialogs/single-entry-dialog/single-entry-dialog.component';
import { LoginService } from './login.service';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    providers: [LoginService],
    standalone: false
})
export class LoginComponent {
  public loginForm: UntypedFormGroup;

  constructor(private service: LoginService, public dialog: MatDialog) {
    this.loginForm = new UntypedFormGroup({
      username: new UntypedFormControl(null, [Validators.required]),
      password: new UntypedFormControl(null, [Validators.required])
    });
  }

  private validateForm() {
    this.service.errorMessages = [];
    if (this.loginForm.get('username')?.invalid && this.loginForm.get('username')?.errors?.['required']) {
      this.service.errorMessages.push('Email Address is required');
    }
    if (this.loginForm.get('password')?.invalid && this.loginForm.get('password')?.errors?.['required']) {
      this.service.errorMessages.push('Password is required');
    }
  }

  get formValid() {
    return this.service.errorMessages.length == 0;
  }

  get errorMessages(): string[] {
    return this.service.errorMessages;
  }

  submitClicked() {
    this.validateForm();
    if (this.formValid) {
      const username = this.loginForm.get('username')?.value?.trim();
      this.service.login(username, this.loginForm.get('password')?.value);
    }
  }

  resetClicked() {
    const dialogData = new SingleEntryDialogModel('Password Reset', 'Email Address', 'You must enter an email address ');
    const dialogRef = this.dialog.open(SingleEntryDialogComponent, { data: dialogData });

    dialogRef.afterClosed().subscribe((dialogResult: SingleEntryDialogResult) => {
      const email = dialogResult?.value?.trim();
      if (!!dialogResult && dialogResult.result && !!email) {
        this.service.passwordReset(email).then(() => {
          const dialogData = new NotificationDialogModel("Password Reset email sent", `A Password Reset email has been sent to ${email} (provided it is registered in Tetras)`);
          this.dialog.open(NotificationDialogComponent, { data: dialogData });
        }).catch(() => {
          const dialogData = new NotificationDialogModel("Password Reset failed", `Failed to send a password reset email to ${email}. Please try again.`);
          this.dialog.open(NotificationDialogComponent, { data: dialogData });
        });
      }
    });
  }

}